export default "__VITE_ASSET__CwhZsrS7__"